/** @griffel:css-start [d] null **/
.fi64zpg{flex-shrink:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f47sw1k{padding-block:var(--spacingVerticalXS);}
.f5j02bv{padding-inline:var(--spacingHorizontalS);}
/** @griffel:css-end **/